import { Box, SimpleGrid, Text, useTheme } from "@chakra-ui/react";

const ColorPalette = () => {
  const theme = useTheme();
  const { colors } = theme;

  return (
    <SimpleGrid columns={5} spacing={10}>
      {Object.keys(colors).map(colorKey => (
        <Box key={colorKey} p={5}>
          {Object.keys(colors[colorKey]).map(shade => (
            <Box key={shade} bg={colors[colorKey][shade]} p={3} borderRadius="md">
              <Text fontSize="sm" color="white">
                {colorKey}-{shade}: {colors[colorKey][shade]}
              </Text>
            </Box>
          ))}
        </Box>
      ))}
    </SimpleGrid>
  );
};

export default ColorPalette;